const HCM_STORE_IDS = new Set([74, 78, 90, 111, 116, 128, 159]);
const BONPAS_STORE_IDS = new Set([1001]);

const getYearFromDateKey = (value) => {
  const match = String(value || "").match(/^(\d{4})-\d{2}-\d{2}/);
  return match ? Number(match[1]) : null;
};

export const getPbbpYearDateRange = (startDate, endDate) => {
  const startYear = getYearFromDateKey(startDate);
  const endYear = getYearFromDateKey(endDate);
  const fallbackYear = new Date().getFullYear();
  const firstYear = Math.min(
    startYear || endYear || fallbackYear,
    endYear || startYear || fallbackYear
  );
  const lastYear = Math.max(
    startYear || endYear || fallbackYear,
    endYear || startYear || fallbackYear
  );

  return {
    startDate: `${firstYear}-01-01`,
    endDate: `${lastYear}-12-31`,
  };
};

const parseNonNegativeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, number) : 0;
};

const normalizeSearchText = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const getOrderLocation = (order) => {
  const storeName = normalizeSearchText(order?.CuaHang);
  const storeId = Number(order?.IDCH);

  if (storeName.includes("bonpas")) return "bonpas";
  if (
    storeName.includes("ho chi minh") ||
    storeName.includes("hcm") ||
    storeName.includes("sai gon")
  ) {
    return "hcm";
  }
  if (BONPAS_STORE_IDS.has(storeId)) return "bonpas";
  if (HCM_STORE_IDS.has(storeId)) return "hcm";

  return "danang";
};

const getOrderQuantity = (order) => {
  if (
    order?.TongSoLuong !== undefined &&
    order?.TongSoLuong !== null &&
    order?.TongSoLuong !== ""
  ) {
    return parseNonNegativeNumber(order.TongSoLuong);
  }

  if (!Array.isArray(order?.ChiTiet)) return 0;

  return order.ChiTiet.reduce(
    (total, item) => total + parseNonNegativeNumber(item?.Slg),
    0
  );
};

export const summarizePbbpSaleOrders = (orders, selectedLocation = "all") => {
  const summary = {
    unconfirmed: 0,
    depositedPendingConfirmation: 0,
    confirmedCompleted: 0,
    total: 0,
  };

  if (!Array.isArray(orders)) return summary;

  orders.forEach((order) => {
    if (
      selectedLocation !== "all" &&
      getOrderLocation(order) !== selectedLocation
    ) {
      return;
    }

    const quantity = getOrderQuantity(order);
    const status = Number(order?.IDTT);

    if ([2, 3].includes(status)) {
      summary.confirmedCompleted += quantity;
    } else if (status === 1) {
      if (parseNonNegativeNumber(order?.TienCoc) > 0) {
        summary.depositedPendingConfirmation += quantity;
      } else {
        summary.unconfirmed += quantity;
      }
    }
  });

  summary.total =
    summary.unconfirmed +
    summary.depositedPendingConfirmation +
    summary.confirmedCompleted;
  return summary;
};
